import React from 'react';
import { motion } from 'framer-motion';

const SectionWrapper = ({ children, setColor, color }) => {
  return (
    <motion.section
      onViewportEnter={() => setColor(color)}
      viewport={{ amount: 0.5, once: false }} // Bölümün %50'si görününce tetikle
    >
      {children}
    </motion.section>
  );
};

export default SectionWrapper;